export default __webpack_public_path__ + "static/media/addBlack.41be7f93.svg";